/* LOGIN */
// eslint-disable-next-line import/prefer-default-export
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
